/** Only illustration labels; the eight full paragraphs stay in translations.ts. */
export const practiceBookCopy: Record<string, string> = {
  'ПРАКТИКА': 'PRACTICE',
  'ЛИЧНОЕ СТАНОВИТСЯ ПРОФЕССИОНАЛЬНЫМ': 'YOUR PLACE IN THE PROFESSION',
  'ПРОФЕССИОНАЛЬНАЯ ПРАКТИКА': 'PROFESSIONAL PRACTICE',
  'ВАШЕ МЕСТО В ПРОФЕССИИ': 'YOUR PLACE IN THE PROFESSION',
  'СЕРТИФИКАЦИЯ АЧП': 'AHM CERTIFICATION',
  'Практиковать.': 'Practice.',
  'Передавать.': 'Pass it on.',
  'ЗНАНИЯ РАБОТАЮТ ДАЛЬШЕ': 'KNOWLEDGE GOES FURTHER',
  'АЧП': 'AHM',
  'ПРАВО НА ПРАКТИКУ': 'THE RIGHT TO PRACTICE',
  'Анна': 'Anna',
  'ПСИХОЛОГ · ПРЕПОДАВАТЕЛЬ': 'PSYCHOLOGIST · EDUCATOR',
  'Знания, у которых': 'Knowledge with',
  'есть продолжение.': 'a future.',
  'Практика': 'A practice',
  'с вашим именем.': 'in your name.',
  'Психолог': 'Psychologist',
  'ВАС УЖЕ ИЩУТ': 'PEOPLE ARE LOOKING FOR YOU',
  'Приложение АЧП': 'AHM app',
  'Поиск · SEO': 'Search · SEO',
  'Ответы ИИ · GEO': 'AI answers · GEO',
  'ВАШ ПРОФИЛЬ': 'YOUR PROFILE',
  'В нужном месте.': 'The right place.',
  'В нужный момент.': 'The right moment.',
  'ВАША ПРАКТИКА': 'YOUR PRACTICE',
  'Среда, 16': 'Wednesday, 16',
  'Рабочий день': 'Your working day',
  'Моделлер': 'Modeler',
  'Расписание': 'Calendar',
  'Сессии': 'Sessions',
  'Переписка': 'Messages',
  'Моя страница': 'My page',
  'СЕГОДНЯ': 'TODAY',
  'Консультация': 'Consultation',
  'Разбор случая': 'Case review',
  'Всё на своём месте.': 'Everything in place.',
  'ПСИХОЛОГ': 'PSYCHOLOGIST',
  'За числами —': 'Behind the numbers:',
  'живая практика.': 'a living practice.',
  'АКТИВНОСТЬ ПРАКТИКИ': 'PRACTICE ACTIVITY',
  'проведённых консультаций': 'completed consultations',
  'ЧИСЛА СЧИТАЕТ ПЛОЩАДКА': 'COUNTED BY THE PLATFORM',
  'Пример данных профиля': 'Illustrative profile data',
  'РЕПУТАЦИЯ': 'REPUTATION',
  'Проверено площадкой': 'Verified by the platform',
  'ЗА ОТЗЫВОМ ЕСТЬ СЕССИЯ': 'A SESSION BEHIND EVERY REVIEW',
  'Сессия состоялась': 'Session completed',
  'Отзыв подтверждён': 'Review verified',
  'Сессии не было': 'No session took place',
  'Отзыв отклонён': 'Review rejected',
  'Доверие нельзя': 'Trust cannot',
  'купить.': 'be bought.',
  'КРЕМНИЕВАЯ ДОЛИНА': 'SILICON VALLEY',
  'ДУБАЙ': 'DUBAI',
  'Технологии': 'Technology',
  'и живые люди.': 'and real people.',
  'Марк': 'Mark',
  'Лейла': 'Leila',
  'Давид': 'David',
  'Елена': 'Elena',
  'Алексей': 'Alex',
  'Майя': 'Maya',
  'Артём': 'Artem',
  'РАЗНЫЕ ЛЮДИ.': 'DIFFERENT PEOPLE.',
  'ОБЩИЙ ЯЗЫК.': 'ONE LANGUAGE.',
}
